import { FetchPolicy } from 'apollo-client';
import { call, getContext } from 'redux-saga/effects';
import { SagaContext } from 'shared/types/common';
import { Services } from 'init/services';
import { ideaQuery } from 'queries/IdeaQuery/builder';
import { IdeaQuery, IdeaQuery_lab_idea } from 'queries/IdeaQuery/__generated__/IdeaQuery';

export function* getIdea(id: number, fetchPolicy: FetchPolicy = 'network-only') {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  const { data }: { data: IdeaQuery } = yield call(
    apolloClient.query,
    ideaQuery({ id }, fetchPolicy)
  );
  return data.lab.idea;
}

export type Idea = IdeaQuery_lab_idea;
